<template>
      <div class="programEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'program', params: {} }">
          Program
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'programEdit', params:{id: id} }">
            Edit Program
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Program</v-card-title>
          <v-card-text>
            <program-form :id="id"></program-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import ProgramForm from './ProgramForm.vue';

    export default {
      name: 'program',
      data () {
        return {
          id: null
        }
      },
      components: {
        ProgramForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    